module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-43.49b2ef61.png";